import { COLOR } from '../../themes'
export const LIST_ROOM = {
  NAME: {
    TH: 'พื้นที่การประชุม',
    EN: 'Meeting Spaces'
  },
  CLEAR: {
    TH: 'ลบรายการที่สนใจ',
    EN: 'Clear all Favourite'
  },
  BUSY: {
    TH: 'ไม่ว่าง',
    EN: 'Busy'
  },
  AVAILABLE: {
    TH: 'ว่าง',
    EN: 'Available'
  },
  NO_IMAGE: {
    TH: 'ไม่มีรูปภาพ',
    EN: 'No Image'
  },
  NOT_LIST: {
    TH: 'ไม่มีข้อมูล',
    EN: 'Don\'t have data list.'
  },
  FAVOURITE: {
    TH: 'รายการที่สนใจ',
    EN: 'Favourite'
  },
  FLOOR: {
    TH: 'ชั้น',
    EN: 'Floor'
  },
  LOAD: {
    TH: 'กำลังโหลดรายการห้อง',
    EN: 'Loading list room...'
  },
  NO_ROOM: {
    TH: 'ไม่มีห้องประชุม',
    EN: "Don't have meeting space."
  },
  NO_BOOKMARK: {
    TH: 'ไม่พบห้องที่บันทึกไว้',
    EN: 'No bookmarked room found.'
  },
  ALL_SPACES: {
    TH: 'พื้นที่ทั้งหมด',
    EN: 'All Spaces'
  },
  MY_FAVORITE: {
    TH: 'รายการโปรดของฉัน',
    EN: 'My Favorite'
  },
  SEARCH_SPACES: {
    TH: 'ค้นหาพื้นที่...',
    EN: 'Search spaces...'
  },
  SELECT_TYPE: {
    TH: 'เลือกประเภท',
    EN: 'Select Type'
  },
  CAPACITY: {
    TH: 'จำนวนคน',
    EN: 'Capacity'
  },
  SPACE_STATUS: {
    TH: 'สถานะพื้นที่',
    EN: 'Space Status'
  },
  CLEAR_FILTER: {
    TH: 'ล้างตัวกรอง',
    EN: 'Clear filter'
  },
  PERSON: {
    TH: 'คน',
    EN: 'person'
  },
  PERSONS: {
    TH: 'คน',
    EN: 'persons'
  }
}

export const FILTER_DEFAULT = 'all'

export const SPACE_TYPE = {
  DESK: 'desk',
  ROOM: 'room',
  OTHER: 'other',
}

export const SPACE_TYPE_LIST = [SPACE_TYPE.ROOM, SPACE_TYPE.DESK, SPACE_TYPE.OTHER]

export const SPACE_TYPE_LABEL = {
  [SPACE_TYPE.ROOM]: { TH: 'ห้อง', EN: 'Room' },
  [SPACE_TYPE.DESK]: { TH: 'โต๊ะ', EN: 'Desk' },
  [SPACE_TYPE.OTHER]: { TH: 'อื่น ๆ', EN: 'Other' },
}

export const SPACE_STATUS = {
  AVAILABLE: 'available',
  BUSY: 'busy',
  IS_USING: {
    AVAILABLE: 0,
    BUSY: 1,
  },
  LABEL: {
    available: LIST_ROOM.AVAILABLE,
    busy: LIST_ROOM.BUSY,
  },
  COLOR: {
    available: { text: '#059669', bg: '#D1FAE5' },
    busy: { text: '#DC2626', bg: '#FFE2E2' },
  }
}

export const TAB_KEY = {
  ALL_SPACES: 'ALL_SPACES',
  MY_FAVORITE: 'MY_FAVORITE',
}

export const SPACE_TYPE_OPTIONS = [
  { value: FILTER_DEFAULT, label: LIST_ROOM.SELECT_TYPE, hideInMenu: true },
  ...SPACE_TYPE_LIST.map(value => ({ value, label: SPACE_TYPE_LABEL[value] })),
]

export const CAPACITY_OPTIONS = [
  { value: FILTER_DEFAULT, label: LIST_ROOM.CAPACITY, hideInMenu: true },
  { value: '1-5', label: '1-5' },
  { value: '6-10', label: '6-10' },
  { value: '11-15', label: '11-15' },
  { value: '16-20', label: '16-20' },
]

export const STATUS_OPTIONS = [
  { value: FILTER_DEFAULT, label: LIST_ROOM.SPACE_STATUS, hideInMenu: true },
  { value: SPACE_STATUS.AVAILABLE, label: SPACE_STATUS.LABEL.available },
  { value: SPACE_STATUS.BUSY, label: SPACE_STATUS.LABEL.busy },
]

export const FALLBACK_SPACE_TYPE_THEME = {
  all: { bg: '#404040', text: '#FAFAFA' },
  [SPACE_TYPE.DESK]: { bg: '#525252', text: '#FAFAFA' },
  [SPACE_TYPE.ROOM]: { bg: '${COLOR.GRAY_5}', text: '#262626' },
  [SPACE_TYPE.OTHER]: { bg: '#171717', text: '${COLOR.GRAY_5}' },
}





